import moment from "moment";
import "moment/locale/id";
import {
    DaftarKategoriListInvoice,
    GetDetailInvoiceResponse,
} from "../../constants/types";

export type StrukCartItem = {
    id: number;
    namaBarang: string;
    namaKategori: string;
    sku?: string;
    qty: number;
    harga: number;
    jumlahStok?: number;
};

export type StrukData = {
    cart: StrukCartItem[];
    category?: DaftarKategoriListInvoice[];
    total: number;
    diskon?: number;
    pajak?: number;
    pajakPersen?: number | null;
    serviceCustom?: number;
    serviceCustomPersen?: number | null;
    tunai?: number;
    kembalian?: number;
    kasir: string;
    sales: string | null;
    tanggalTransaksi: string;
    transaksiKe: string;
    nomorInvoice?: string | null;
    namaMetode?: string | null;
    noMetode?: string | null;
    namaPemegang?: string | null;
    qr?: string | null;
    keterangan?: string | null;
    belumLunas?: boolean;
    meja?: {
        id: number | null;
        nomor: string | null;
        ruangan: string | null;
        kapasitas: number | null;
    };
    pelangganWebstore?: string;
};

type DetailInvoice = GetDetailInvoiceResponse["data"];

export const strukDataFromInvoice = (invoice: DetailInvoice): StrukData => ({
    cart: invoice.daftarItem.map((item, index) => ({
        id: index,
        namaBarang: String(item.namaItem),
        namaKategori: String(item.namaKategori),
        qty: Number(item.jumlahItem),
        harga: Number(item.hargaSatuan),
    })),
    category: invoice.daftarKategori,
    total: invoice.totalPembayaran,
    diskon: invoice.diskon,
    pajak: invoice.pajak,
    pajakPersen: invoice.pajakPersen,
    serviceCustom: invoice.serviceCustom,
    serviceCustomPersen: invoice.serviceCustomPersen,
    tunai: invoice.uangYangDibayar,
    kembalian: invoice.kembalian,
    kasir: invoice.kasir,
    sales: invoice.sales,
    tanggalTransaksi: moment(invoice.tanggalTransaksi).format(
        "DD MMM YYYY HH:mm",
    ),
    transaksiKe: invoice.transaksiKe,
    nomorInvoice: invoice.nomorInvoice,
    namaMetode: invoice.metode ?? "Tunai",
    noMetode: invoice.metodeArr.noTujuan,
    namaPemegang: invoice.metodeArr.namaPemegang,
    qr: invoice.metodeArr.gambar,
    keterangan: invoice.keterangan,
    meja: invoice.meja,
    pelangganWebstore: invoice.pelangganWebstore?.namaPelanggan || undefined,
});
